import { getComponentName } from '../../../helpers/componentHelpers';
import { GridItemDetailsColumnClass } from './GridItemDetailsColumnClass';
import '@vaadin/icon';
import '@vaadin/icons';

export const componentName = getComponentName('grid-item-details-column');

customElements.define(componentName, GridItemDetailsColumnClass);
